// src/components/blog/BlogSearch.jsx

import React, { memo } from 'react';

const BlogSearch = memo(({ searchQuery, onSearchChange, isDark, resultCount = null }) => {
  return (
    <div className="relative">
      <svg 
        className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
      <input
        type="text"
        placeholder="Search articles..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className={`w-full pl-10 pr-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 transition-all ${
          isDark 
            ? 'bg-white/10 border-white/20 text-white placeholder:text-gray-500' 
            : 'bg-gray-50 border-gray-300 text-gray-900 placeholder:text-gray-400'
        }`}
        aria-label="Search blog posts"
      />
      {resultCount !== null && searchQuery && (
        <p className={`text-xs mt-2 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
          Found {resultCount} result(s)
        </p>
      )}
    </div>
  );
});

BlogSearch.displayName = 'BlogSearch';

export default BlogSearch;